<script setup lang="ts">
interface Props {
  products: any,
  index?: number
}
const props = defineProps<Props>()
const stats = computed(() => props.products.extensions.stats)
const rating = computed(() => {
  if (stats.value?.length > 0) {
    return {
      reviews: stats.value[0].reviewCount,
      ratingAverage: stats.value[0].averageRating
    }
  } else if (props.products.productReviews) {
    return {
      reviews: props.products.productReviews.length,
      ratingAverage: props.products.ratingAverage
    }
  }

  return null
})
const price = computed(() => {
  if (props.products.extensions.stats && props.products.extensions.stats.length) {
    return {
      base: true,
      value: props.products.extensions.stats[0].cheapestPrice ? props.products.extensions.stats[0].cheapestPrice.price[0].gross : 0
    }
  }
  return {
    value: props.products.calculatedPrices[0]?.unitPrice || props.products.calculatedPrice?.unitPrice || 0,
    listPrice: props.products.calculatedPrices[0]?.listPrice || props.products.calculatedPrice?.listPrice || 0
  }
})
const isNew = computed(() => !!props.products.customFields?.product_productNewLabel || !!props.products.customFields?.category_categoryNewLabel)
const isBestseller = computed(() => !!props.products.customFields?.product_isForcedBestseller || !!props.products.customFields?.product_isBestseller || !!props.products.customFields?.category_isForcedBestseller || !!props.products.customFields?.category_isBestseller)
const promotion = computed(() => price.value.listPrice?.price > price.value.value)
const getLocalizations = (productCity: string, rootProductCount: number, stats: any) => {
  if (stats && stats.length) {
    const statsRootProductCount = stats[0]?.rootProductCount || 0
    if (statsRootProductCount === 1) {
      return productCity
    } else if (statsRootProductCount >= 2 && statsRootProductCount < 5) {
      return `${statsRootProductCount} lokalizacje`
    } else if (statsRootProductCount >= 5) {
      return `${statsRootProductCount} lokalizacji`
    }
  }
  if (rootProductCount === 1) {
    return productCity
  } else if (rootProductCount === 2) {
    return '+ 1 lokalizacja'
  } else if (rootProductCount >= 3 && rootProductCount <= 5) {
    return `+ ${rootProductCount - 1} lokalizacje`
  } else if (rootProductCount > 5) {
    return `+ ${rootProductCount - 1} lokalizacji`
  }
}
</script>

<template>
  <NuxtLink :to="`/${products.extensions.urlPrefix.prefix}/${products.seoUrls?.[0].seoPathInfo}`" class="flex flex-col">
    <span class="relative overflow-hidden">
      <Img
        v-if="products.cover"
        :src="products.cover.media.url"
        width="262"
        height="341"
        :alt="products.cover.media.alt || products.name"
        :loading="index !== null && index < 2 ? 'eager' : 'lazy'"
        class="block transform-gpu duration-500 group-hover:scale-110"
      />
      <Img
        v-else-if="products.media"
        :src="products.media.url"
        width="262"
        height="341"
        :alt="products.media.alt || products.name"
        :loading="index !== null && index < 2 ? 'eager' : 'lazy'"
        class="block transform-gpu duration-500 group-hover:scale-110"
      />
      <Labels :new="isNew" :bestseller="isBestseller" :promotion="promotion" />
      <span class="text-white absolute bottom-0 w-full bg-[linear-gradient(180deg,#00000000_0%,#000000E6_100%)] px-[10px] pt-[25px] pb-[5px]">
        <RatingDisplay :rating-average="rating?.ratingAverage || 0" :reviews="rating?.reviews || 0" />
        <span class="flex items-center gap-[5px] text-16 text-white">
          <span v-if="price.base">od</span>
          <Price v-if="promotion" :value="price.listPrice.price" class="text-14 text-primary line-through mr-[10px]" />
          <Price :value="price.value" />
        </span>
      </span>
    </span>
    <div class="h-[80px] flex flex-col overflow-hidden text-ellipsis">
      <span class="text-12 md:text-14 font-medium mt-[10px] line-clamp-2">{{ products.name }}</span>
      <span class="text-12 text-gray-400 mt-[10px] line-clamp-1">{{ getLocalizations(products.customFields.product_city, products.customFields.rootProductCount, products.extensions.stats) }}</span>
    </div>
  </NuxtLink>
</template>
